<mat-form-field color="accent" class="form-group">
  <mat-label>{{ labelT | translate }}</mat-label>
  <mat-select [formControlName]="controlKey">
    <mat-option *ngIf="includeEmptyOption"></mat-option>
    <mat-option *ngFor="let item of itemsInternal; trackBy: trackByOption" [value]="item.value">
      {{ item.label }}
    </mat-option>
  </mat-select>
  <mat-error *ngFor="let err of errorsArray; trackBy: trackBy">
    {{ displayErrorMessage(err) }}
  </mat-error>
</mat-form-field>